import { Stamp } from './Stamp.js';

const STEPS: ReadonlyArray<{ n: string; title: string; description: string }> = [
  {
    n: '01',
    title: 'Exporta seu PDF do LinkedIn',
    description:
      'Mais > Salvar como PDF, direto no seu perfil. A gente não pede seu login do LinkedIn e nem acessa sua conta de qualquer outra forma.',
  },
  {
    n: '02',
    title: 'Conecta sua chave de IA',
    description:
      'Você usa a IA que preferir (Google, Anthropic ou OpenAI). O Gemini do Google tem 1500 chamadas grátis por dia, sem pedir cartão. A chave vive só na sua sessão de memória, nunca chega ao nosso banco.',
  },
  {
    n: '03',
    title: 'Roda o diagnóstico',
    description:
      'A IA passa pela headline, sobre, experiências e demais seções do seu perfil e devolve uma lista de pontos pra ajustar, cada um com o motivo fundamentado e uma reescrita pronta. Nada de conselho genérico tipo "seja autêntico".',
  },
  {
    n: '04',
    title: 'Gera posts no seu estilo',
    description:
      'Cola a URL de um post do LinkedIn, escolhe um assunto em alta, ou sobe um texto de referência. Saem três a cinco rascunhos prontos pra copiar, com ganchos variados, considerando até a imagem do post original.',
  },
];

export function HowItWorks() {
  return (
    <section id="how" className="border-b border-[var(--border-subtle)] py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-6">
        <header className="max-w-2xl">
          <Stamp>fluxo · 4 passos</Stamp>
          <h2 className="mt-4 font-serif text-[36px] font-medium leading-[1.1] tracking-[-0.02em] text-[var(--ink-primary)] sm:text-[44px]">
            Como funciona<span className="text-[var(--accent-saffron)]">.</span>
          </h2>
          <p className="mt-3 font-sans text-base text-[var(--ink-secondary)]">
            Quatro passos, todos no seu controle. Sem aquele cadastro com doze telas pra preencher,
            sem reunião comercial obrigatória, e sem cobrança que aumenta cada vez que alguém do
            seu time se inscreve.
          </p>
        </header>

        <ol className="mt-14 grid gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, i) => (
            <li
              key={step.n}
              className="relative"
              style={{
                // Linha conectando os passos (só desktop)
                borderTop: i > 0 ? '1px dashed var(--border-default)' : 'none',
                paddingTop: i > 0 ? '0' : '0',
              }}
            >
              <div className="flex items-baseline gap-3">
                <span className="font-mono text-3xl tabular-nums text-[var(--accent-saffron)]">
                  {step.n}
                </span>
                <span
                  aria-hidden
                  className="h-px flex-1 bg-[var(--border-subtle)]"
                />
              </div>
              <h3 className="mt-4 font-serif text-xl font-medium text-[var(--ink-primary)]">
                {step.title}
              </h3>
              <p className="mt-2 font-sans text-sm leading-relaxed text-[var(--ink-secondary)]">
                {step.description}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
